<template>
  <h3>Kam se mnou na tábor v roce 2026?</h3>
    <p>Na příští rok plánuji 2 tábory na Fryšavě.</p>
    <p>první bude na jaře v termínu <b>30. 4. - 3. 5. 2026</b></p>
    <p>druhý se bude konat na podzim <b>7. - 13. 9. 2026</b></p>
    <p>Propozice pro oba tábory budou zveřejněné a přihlašování bude spuštěné do konce letošního roku.</p>
  <h3>Proběhlé tábory</h3>
    <h5>Podzim 2025</h5>
      <p><b>Kdy?</b> 2. - 5. 10. </p>
      <p><b>Kde?</b> Fryšava pod Žákovou horou - Chalupa na konci světa</p>
      <p>V závislosti na počasí a vašem zájmu se může dít následující:<br>

        společné vycházky<br>
        základy práce na uvědomění si těla (targety, balančky, uvědomění si zadních nohou....)<br>
        sebekontrolní hry<br>
        přivolání<br>
        odložení<br>
        pozornost<br>
        trénink prvků základní poslušnosti nebo různých triků<br>
        práce s rušivkami<br>
        ošetření se souhlasem<br>
      </p>

    <h5>Jaro 2025</h5>
        <p><b>Kdy?</b> Na přelomu dubna a května </p>
        <p><b>Kde?</b> na Fryšavě na úplně úžasném místě</p>
        <!--<p>S kým? Pořádá psí škola Psí škola Dancing Dogs a jako trenér tam bude Katka Lerlova a já 🙂</p>-->
        <p>Na táboře se budeme věnovat převážně <b>pozornosti a přivolání</b> a to i mezi rušivkami. Jak v běžném životě rodinného psa, tak pro sportovní psy, 
          kteří se potýkají s nepozorností na trénincích nebo zkouškách a závodech, nebo dokonce z placu odcházejí. Co ještě může tábor nabídnout? 
          Můžeme se spolu podívat i na další oblasti vašeho soužití se psím parťákem – například slušnou chůzi na prověšeném vodítku, 
          jak správně psa něco nového učit a třeba odhalíme nějaké nešvary, kvůli kterým v tréninku nepostupujete tak rychle, jak byste chtěli. 
          Pokud budete mít zájem, můžeme zapracovat například i na ošetření se souhlasem.</p>
</template>

<script>
import { useMeta } from 'vue-meta'

export default {
  name: 'Tabory',

  setup () {
    useMeta({ title: 'Člověk a pes spolu - pořádané tábory' })
  },

}

</script>

<style lang="scss">
a {
  color: $secondary
}
</style>
